<template>
  <div class="item" :class="{active: isActive}">
    <div class="checkbox" :class="{radio: type === 'radio'}">
      <input v-if="type === 'checkbox'" type="checkbox" name="libraryItem"
        :id="item.id"
        :value="item.id"
        v-model="active">
      <input v-else-if="type === 'radio'" type="radio" name="libraryItem"
        :id="item.id"
        :value="item.id"
        v-model="selected">
      <label :for="item.id">
        <div class="chInfo">
          <div class="chLogo"><img :src="item.logo" alt=""></div>
          <div class="chName">{{item.name}}</div>
        </div>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'locale',
    'item',
    'type',
    'activeItem',
    'selectedItem'
  ],
  computed: {
    active: {
      get () {
        return this.activeItem
      },
      set (ids) {
        this.$emit('onActiveItem', ids)
      }
    },
    selected: {
      get () {
        return this.selectedItem
      },
      set (id) {
        this.$emit('onSelectedItem', id)
      }
    },
    isActive () {
      return this.activeItem.includes(this.item.id) || this.selectedItem === this.item.id
    }
  },
  methods: {
    onClose () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.chList {
  .item {
    width: 12.5%;
    margin-bottom: 0;
    margin-left: 0;
    padding: 2px;
    border-radius: 0;
    border: none;
    box-shadow: none;
    text-align: initial;
    .checkbox {
      display: block;
      position: relative;
      margin-right: 0;
      cursor: pointer;
      label {
        padding-left: 0;
      }
      label:before {
        top: 5px;
        left: 5px;
      }
    }
    .chInfo {
      text-align: center;
      border: 1px solid $color-lgrey2;
      background-color: $color-white;
    }
    .chName {
      margin-top: 5px;
      padding: 5px;
      font-size: 0.85em;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      border-top: 1px solid $color-lgrey2;
    }
    .chLogo {
      padding: 5px;
    }
  }
  .active .chInfo {
    border-color: $color-dark;
  }
}
</style>
